import script from "./BuildingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingForm.vue?vue&type=script&setup=true&lang=js"

import "./BuildingForm.vue?vue&type=style&index=0&id=4507c04d&scoped=true&lang=css"
import "./BuildingForm.vue?vue&type=style&index=1&id=4507c04d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4507c04d"]])

export default __exports__